/* eslint-disable */

/** the context where the request happens */
export enum Context {
  CONTEXT_UNSPECIFIED = "CONTEXT_UNSPECIFIED",
  OFFER_TAB = "OFFER_TAB",
  SHOP_HUB = "SHOP_HUB",
  DISCOVER = "DISCOVER",
  AFTERPAY = "AFTERPAY",
  INTERNAL = "INTERNAL",
  TOOLBOX_ANONYMOUS = "TOOLBOX_ANONYMOUS",
  SHADOW_CASH = "SHADOW_CASH",
  SHADOW_AFTERPAY = "SHADOW_AFTERPAY",
}

/** the response when a request fails */
export interface ErrorResponse {
  code?: number;
  message?: string;
}
